export default __webpack_public_path__ + "static/media/icon_08_tools.f53fd2a5.svg";